import { defineCustomElement } from '@tyler-components-web/core';
import { DrawerComponent } from './drawer';
export * from './drawer-adapter';
export * from './drawer-constants';
export * from './drawer-foundation';
export * from './drawer';
export function defineDrawerComponent() {
    defineCustomElement(DrawerComponent);
}
